/**
 * Quick Add — Click to Quick Add
 *
 * Reuses Shopify's own "Standard" quick-add markup (modal-opener + quick-add-modal, or a plain
 * add-to-cart form for single-variant products -- see snippets/quick-add-custom-click-quickview.liquid)
 * but its trigger button is visually hidden. This element listens for a click on the card's own
 * title link -- which the theme's CSS already stretches to cover the whole card (image, price,
 * title) -- and forwards it to that hidden button, so clicking anywhere on the card opens the
 * quick-add modal (or adds straight to cart for single-variant products) instead of navigating
 * to the product page. The modal itself still has its own "View full details" link back to the
 * real product page, and plain navigation still works via modifier-clicks (cmd/ctrl/shift/middle
 * click), so the product page remains reachable.
 */
if (!customElements.get('quick-add-click-trigger')) {
  customElements.define(
    'quick-add-click-trigger',
    class QuickAddClickTrigger extends HTMLElement {
      connectedCallback() {
        this.triggerButton = this.querySelector('button');
        if (!this.triggerButton) return;

        this.cardWrapper = this.closest('.card-wrapper');
        if (!this.cardWrapper) return;

        this.titleLinks = Array.from(this.cardWrapper.querySelectorAll('.card__heading a'));
        if (!this.titleLinks.length) return;

        this.titleLinks.forEach((link) => {
          link.addEventListener('click', this.onTitleLinkClick.bind(this));
        });
      }

      onTitleLinkClick(event) {
        // Let modifier-clicks and middle-clicks behave normally (open the product page in a
        // new tab, etc.) instead of hijacking them into the quick-add trigger.
        if (event.defaultPrevented || event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        if (this.triggerButton.disabled || this.triggerButton.getAttribute('aria-disabled') === 'true') return;

        event.preventDefault();
        this.triggerButton.click();
      }
    }
  );
}
